import { useQuery } from '@apollo/react-hooks';
import { useMemo } from 'react';
import USER_ROLE from 'graphql/queries/userRole.graphql';

function useRole({ skip = false } = {}) {
  const { data, loading, error } = useQuery(USER_ROLE, { skip });

  const [role, queryInfos] = useMemo(
    () => [data?.userRole, { data, loading, error }],
    [data, loading, error],
  );

  return [role, queryInfos];
}

export default useRole;
